<template>
  <v-container class="px-10" fluid>
    <v-row>
      <v-col cols="12" class="px-0">
        <campos-filtros
          id="campos-filtros"
          ref="refCamposFiltros"
          :campos="items.field"
          :title="title"
          icon="mdi-tab-search"
          @loading="loading.query = $event"
        >
          <template slot="before-filters">
            <v-row>
              <v-col class="pl-2" cols="6">
                <v-radio-group v-model="selectedTab" row>
                  <v-radio v-for="option in radioOptions" :key="option.value" :label="option.label" :value="option.value" />
                </v-radio-group>
              </v-col>
            </v-row>
          </template>
        </campos-filtros>

        <div class="d-flex justify-end mt-5">
          <v-btn color="success" min-width="100" :loading="loading.save" @click="consultarAba()">Extrair</v-btn>
          <v-btn class="mr-0" color="primary" min-width="100" :loading="loading.query" @click="getDadosAba(true)">Filtrar</v-btn>
        </div>
      </v-col>

      <v-col cols="12" class="px-0">
        <base-card class="px-5 py-3">
          <v-tabs v-model="tabs" fixed-tabs align-tabs="start" bg-color="transparent">
            <v-tabs-slider color="primary" />

            <v-tab href="#tab-history" class="text-primary">
              <v-icon start>mdi-view-list</v-icon>
              Extrações
            </v-tab>

            <v-tab href="#tab-query-data" class="text-primary">
              <v-icon start>mdi-database</v-icon>
              Dados Filtrados
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs">
            <v-tab-item value="tab-history">
              <v-text-field
                id="analises-historico-search"
                v-model="search"
                append-icon="mdi-magnify"
                class="break-search mb-3 ml-auto mt-3"
                label="Procurar"
                hide-details
                single-line
                style="max-width: 250px"
              />
              <v-data-table
                :headers="headers.history"
                :items="items.history"
                :loading="loading.history"
                :hide-default-footer="loading.history"
                :mobile-breakpoint="10"
                :search.sync="search"
                loading-text="Carregando tabela"
                no-data-text="Nenhum registro disponível"
                no-results-text="Nenhum registro correspondente encontrado"
              >
                <template v-slot:[`item.data_processamento`]="{ item }">
                  {{ item.data_processamento | parseToDateTimeBR }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <general-status :status="item.status" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    id="baixar-extracao"
                    min-width="0"
                    class="px-1"
                    fab
                    icon
                    x-small
                    :loading="loading.download[item.id]"
                    :disabled="item.status === 'SUCESSO' ? false : true"
                    @click="baixarExtracao(item)"
                  >
                    <v-icon medium>mdi-download</v-icon>
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        id="action-more-conciliacao"
                        color="white"
                        class="ml-1"
                        height="22px"
                        width="22px"
                        fab
                        x-small
                        elevation="1"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="
                          ((dialogCreationLog = true),
                          (dialogCreationLogData = {
                            username: item.usuario.name,
                            created: item.created_at
                          }))
                        "
                      >
                        <v-list-item-title>
                          <v-icon small>mdi-table-search</v-icon>
                          Log
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:[`footer.page-text`]>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" v-bind="attrs" v-on="on" @click="getHistoricoConsultaConciliacaoAba">
                        mdi-refresh
                      </v-icon>
                    </template>
                    <span>Clique aqui para recarregar as Consultas de Conciliação por Aba</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item value="tab-query-data">
              <v-row>
                <v-col class="pa-4" cols="12">
                  <v-alert dense outlined type="info" color="blue" class="mb-3 mt-3 px-1 py-1">
                    <span>
                      Esta tela exibe no máximo
                      <strong>{{ limit | parseNumberToIntegerBR }}</strong>
                      registros. Sua consulta retornou
                      <strong>{{ numRegistros | parseNumberToIntegerBR }}</strong>
                      .
                    </span>
                  </v-alert>
                </v-col>
                <v-col class="pt-0" cols="12">
                  <v-data-table
                    :headers="headers.query"
                    :items="items.query"
                    :loading="loading.query"
                    :hide-default-footer="loading.query"
                    :mobile-breakpoint="10"
                    loading-text="Carregando tabela"
                    no-data-text="Nenhum registro disponível"
                    no-results-text="Nenhum registro correspondente encontrado"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </base-card>
      </v-col>
    </v-row>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </v-container>
</template>

<script>
  import ConciliacaoConsultaAba from '@/services/ConciliacaoConsultaAba';

  export default {
    name: 'ExtracoesGeoPerdasIndex',

    components: {
      CamposFiltros: () => import('@/components/relatorios/CamposFiltros'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog')
    },

    data: () => ({
      items: {
        history: [],
        field: [],
        query: []
      },
      headers: {
        history: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Executado',
            value: 'data_processamento'
          },
          {
            text: 'Status',
            value: 'status'
          },
          { sortable: false, text: '', value: 'actions', class: 'pl-4' }
        ],
        query: []
      },
      loading: {
        history: false,
        field: false,
        query: false,
        save: false,
        download: []
      },
      tabs: null,
      selectedTab: 'CONCILIACAO',
      radioOptions: [
        { label: 'Conciliado', value: 'CONCILIACAO' },
        { label: 'Partida', value: 'CONTABIL' },
        { label: 'Referência', value: 'FISICO' }
      ],
      search: '',
      limit: 1000,
      numRegistros: 0,
      dialogCreationLog: false,
      dialogCreationLogData: {},
      firstLoad: true
    }),

    computed: {
      title() {
        return `Consulta da Aba ${this.nomeAbaConciliacaoSelecionada} – ${this.nomeConciliacao}`;
      },

      conciliacaoId() {
        return this.$route.params.conciliacaoId;
      },

      nomeConciliacao() {
        return this.$route.params.nomeConciliacao;
      },

      nomeAbaConciliacaoSelecionada() {
        switch (this.selectedTab) {
          case 'CONTABIL':
            return 'Partida';
          case 'FISICO':
            return 'Referência';
          case 'CONCILIACAO':
            return 'Conciliado';
          default:
            return '';
        }
      },

      userLoggedCompany() {
        return this.$store.getters.getSelectedCompany;
      }
    },

    mounted() {
      this.getHistoricoConsultaConciliacaoAba();
      this.getTabelaColunas();
      this.getDadosAba();
    },

    methods: {
      getHistoricoConsultaConciliacaoAba() {
        this.loading.history = true;
        ConciliacaoConsultaAba.getHistoricoConsultaConciliacaoAba(this.conciliacaoId, this.selectedTab)
          .then(({ data }) => {
            this.items.history = data;
          })
          .catch((err) => {
            console.error('Erro:', err);
            this.$toast.error(
              `Erro ao recuperar o histórico de consultas para a aba ${this.nomeAbaConciliacaoSelecionada}.`,
              '',
              { position: 'topRight' }
            );
          })
          .finally(() => {
            this.loading.history = false;
          });
      },
      getTabelaColunas() {
        this.loading.field = true;
        ConciliacaoConsultaAba.getTabelaColunas(this.conciliacaoId, this.selectedTab)
          .then(({ data }) => {
            this.items.field = data;
          })
          .catch((err) => {
            console.error('Erro:', err);
            this.$toast.error(`Erro ao recuperar os campos para a aba ${this.nomeAbaConciliacaoSelecionada}.`, '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading.field = false;
          });
      },
      getDadosAba(returnToFirstTab = false) {
        this.loading.query = true;

        if (this.firstLoad) {
          this.firstLoad = false;
        } else if (returnToFirstTab) {
          this.tabs = 'tab-query-data';
        }

        const filtros = this.$refs.refCamposFiltros ? this.$refs.refCamposFiltros.exportCampos() : {};
        ConciliacaoConsultaAba.getDadosAba(this.conciliacaoId, this.selectedTab, filtros, this.limit)
          .then(({ data }) => {
            const meta = data && data.meta ? data.meta : {};
            const registros = data && Array.isArray(data.data) ? data.data : [];

            const chavesColunas = Object.keys(registros.length ? registros[0] : {});
            const nomesFormatadosColunas = meta.nomesFormatadosColunas || [];

            this.headers.query = [
              ...chavesColunas.map((chave, i) => ({
                value: chave,
                text: nomesFormatadosColunas[i] || chave,
                align: 'center'
              }))
            ];

            this.items.query = registros;
            this.numRegistros = meta.numRegistros || 0;
          })
          .catch((err) => {
            console.error('Erro:', err);
            this.$toast.error(`Erro ao recuperar as linhas importadas da aba ${this.nomeAbaConciliacaoSelecionada}.`, '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading.query = false;
          });
      },
      consultarAba() {
        this.loading.save = true;
        this.tabs = 'tab-history';

        const dadosConsulta = {
          aba: this.selectedTab,
          conciliacao_id: this.conciliacaoId,
          company_id: this.userLoggedCompany ? this.userLoggedCompany.id : null,
          filtros: this.$refs.refCamposFiltros ? this.$refs.refCamposFiltros.exportCampos() : {}
        };

        ConciliacaoConsultaAba.consultarAba(dadosConsulta)
          .then(() => {
            this.getHistoricoConsultaConciliacaoAba();

            this.$toast.success(`Consulta de conciliação na aba ${this.nomeAbaConciliacaoSelecionada} salva com sucesso.`, '', {
              position: 'topRight'
            });
          })
          .catch((err) => {
            console.error('Erro:', err);
            this.$toast.error(`Erro ao salvar a consulta de conciliação da aba ${this.nomeAbaConciliacaoSelecionada}.`, '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading.save = false;
          });
      },
      baixarExtracao(item) {
        this.$set(this.loading.download, item.id, true);
        ConciliacaoConsultaAba.baixarExtracao(item.id, {
          timeout: 60 * 60 * 1000
        })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `conciliacao-consulta-aba-${item.id}.csv`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download da consulta.', '', {
              position: 'topRight'
            });
          })
          .finally(() => this.$set(this.loading.download, item.id, false));
      }
    },
    watch: {
      selectedTab() {
        this.$refs.refCamposFiltros.restaurarFiltrosPadrao();

        this.getHistoricoConsultaConciliacaoAba();
        this.getTabelaColunas();
        this.getDadosAba();
      }
    }
  };
</script>

<style></style>
